import { useTranslation } from "~contexts/I18nContext/I18nContext.tsx";
import styles from "./ErrorPages.module.scss";
import { SignOutButton } from "./SignOutButton.tsx";

export function Forbidden() {
  const t = useTranslation();

  return (
    <div className={styles.container}>
      <h1>{t.forbiddenHeader}</h1>
      <div>
        <p>{t.forbiddenText}</p>
        <p className={styles.contacts}>{t.forbiddenFooter}</p>
      </div>
      <SignOutButton />
    </div>
  );
}
